import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Dropdown, Tabs} from 'antd';
import {DeleteFilled, EllipsisOutlined} from '@ant-design/icons';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {StyledBudgetRequestApprovalFlowDeleteModal} from '../BudgetRequestApprovalFlow/StyledBudgetRequestApprovalFlow';
import BudgetRequestApprovalFlow from '../BudgetRequestApprovalFlow';
import DeleteModal from '../../../DeleteModal';
import IconWrapper from '../../../IconWrapper';
import {colorsStyles} from '../../../../utils/styles';
import {DEFAULT_MODAL_PROPS} from '../../../../constants';
import {budgetActions} from '../../../../state/actions/budget.actions';
import {alertActions} from '../../../../state/actions/alert.actions';
import routes from '../../../../routes/routes.json';
import {budgetHelpers} from '../../../../utils/helpers';

const BudgetRequestTabs = ({
  ...rest
}) => {
  const [deleteModalProps, setDeleteModalProps] = useState(DEFAULT_MODAL_PROPS);
  const [t] = useTranslation(['main', 'budgets']);
  const budget = useSelector(state => state?.budget?.budgetRequest);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const isDraftStatus = budgetHelpers.isDraftBudget(budget);

  const getDeleteModalText = (key) => t(`budgets:modal.deleteBudget.${key}`);

  const handleCancelDeleteModal = () => setDeleteModalProps(DEFAULT_MODAL_PROPS);

  const handleOpenDeleteModal = () => setDeleteModalProps({ ...DEFAULT_MODAL_PROPS, open: true });

  const handleOkDeleteModal = () => {
    const budgetId = budget?.id;
    if (!budgetId) return;

    setDeleteModalProps({...DEFAULT_MODAL_PROPS, loading: true});

    dispatch(
      budgetActions.deleteBudgetRequest({
        id: budgetId,
        successCallback: () => {
          handleCancelDeleteModal();
          alertActions.success(t('budgets:alerts.deleteBudgetRequestSuccess'));
          navigate(routes.budgetsRequests);
        },
        errorCallback: () => {
          setDeleteModalProps({...DEFAULT_MODAL_PROPS, loading: false});
          alertActions.error(t('budgets:alerts.deleteBudgetRequestError'));
        }
      })
    );

  }

  const handleMenuClick = ({key}) => {
    if (key === 'delete') handleOpenDeleteModal();
  }

  const items = [
    {
      label: t('approvalFlow'),
      key: 'approval_flow',
      children: <BudgetRequestApprovalFlow />,
    },
    // {
    //   label: t('comments'),
    //   key: 'comments',
    //   disabled: true,
    // },
    // {
    //   label: t('documents'),
    //   key: 'documents',
    //   disabled: true
    // },
  ];

  const menuProps = {
    onClick: handleMenuClick,
    items: [
      {
        label: t('delete'),
        key: 'delete',
        icon: <IconWrapper size={16}><DeleteFilled color={colorsStyles.neutral_7} /></IconWrapper>,
      },
    ],
  };

  const tabBarExtraContent = isDraftStatus && (
    <Dropdown menu={menuProps} placement='bottomRight'>
      <Button size='middle' icon={<EllipsisOutlined />} />
    </Dropdown>
  );

  return (
    <>
      <Tabs
        defaultActiveKey='approval_flow'
        items={items}
        tabBarExtraContent={tabBarExtraContent}
        {...rest}
      />

      <DeleteModal
        onCancel={handleCancelDeleteModal}
        onOk={handleOkDeleteModal}
        title={getDeleteModalText('title')}
        width={480}
        {...deleteModalProps}
      >
        <StyledBudgetRequestApprovalFlowDeleteModal>
          <h5>{getDeleteModalText('content.title')}</h5>
          <p>{getDeleteModalText('content.description')}</p>
        </StyledBudgetRequestApprovalFlowDeleteModal>
      </DeleteModal>

    </>
  );
}

export default BudgetRequestTabs;
